module.exports = __webpack_public_path__ + "static/media/fvs_valve1_80.f5ad5350.jpg";